// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.prototype.axios = axios
axios.defaults.baseURL = process.env.BASE_URL
//  引入Echarts
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(echarts)
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})
// 禁止浏览器前进后退 另一部本在router的index.js中
// window.addEventListener('popstate', function () {
//   history.pushState(null, null, document.URL)
// })
// 无操作退出登录
// let time;
// function resetLogoutTimer() {
//   console.log('重置计时器');
//   clearTimeout(time);
//   time = setTimeout(() => {
//     console.log('检查是否需要执行自动退出');
//     // 只有token存在时才执行退出操作
//     if (localStorage.getItem("token")) {
//       console.log('执行自动退出');
//       // 1. 清除本地存储
//       axios({
//         url: "/Management/logoff",
//         method: "GET",
//         responseType: "json",
//         headers: {
//           mac: localStorage.getItem("mac"),
//           token: localStorage.getItem("token"),
//         },
//       })
//         .then((res) => {
//           if (res.data.code === 200) {
//             this.$router.replace({ path: "/" });
//             location.reload();
//             localStorage.removeItem("fileInfoId");
//             localStorage.removeItem("fileInfoIdname");
//             localStorage.removeItem("companyType");
//             localStorage.removeItem("mac");
//             localStorage.removeItem("token");
//           } else if (res.data.code === 900) {
//             const h = this.$createElement;
//             this.$notify({
//               title: "提示",
//               message: h("i", res.data.message),
//             });
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//       // 3. 如需刷新页面，可保留（建议先测试是否需要）
//       // location.reload();
//     } else {
//       console.log('token不存在，不执行自动退出');
//     }
//   }, 3600000); // 测试时用10秒，正式环境改回3600000（1小时）
// }

// // 页面加载时初始化计时器
// window.addEventListener('load', resetLogoutTimer);

// // 绑定用户操作事件（改绑 window 更稳定）
// const events = ['mousemove', 'keydown', 'click', 'touchmove', 'wheel'];
// events.forEach(event => {
//   window.addEventListener(event, resetLogoutTimer);
// });



// WEBPACK FOOTER //
// ./src/main.js